import React, { Component } from 'react'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { compose, constants } from 'common/helpers'


const postponedLocalStorageNames = [
  constants.localStorageNames.queueProduct,
  constants.localStorageNames.queueProducts,
  constants.localStorageNames.queueLimitedProduct,
  constants.localStorageNames.queueLimitedProducts,
  constants.localStorageNames.cartProduct,
  constants.localStorageNames.skincareIntroItems,
  constants.localStorageNames.makeupLandingItems,
  constants.localStorageNames.makeupLandingNewStyleItems,
  constants.localStorageNames.collectionLandingPageItems,
  constants.localStorageNames.pickYourScentFlowItems,
  constants.localStorageNames.stockNotificationSubscriptionProductId,
]


/**
 * @param {Object} [options]
 * @param {Boolean} [options.shouldFetchQueue]
 * @param {Boolean} [options.skipLimitedItems] - don't resolve limited items (useful for subscription page)
 * @param {Boolean} [options.isNotificationVisible]
 * @returns {function(*): *}
 */
export default (options = {}) => (ComposedComponent) => {

  class WrappedComponent extends Component {

    static WrappedComponent = ComposedComponent

    static displayName = `resolvePostponed(${ComposedComponent.displayName || ComposedComponent.name})`

    componentDidMount() {
      const { isLoggedIn } = this.props

      if (isLoggedIn) {
        this.resolvePostponed()
      }
    }

    resolvePostponed = () => {
      const { shouldFetchQueue, skipLimitedItems, isNotificationVisible } = options
      const { hasPostponedItems } = this.props

      if (hasPostponedItems) {
        actions.models.user.resolveAllPostponedItems({ isNotificationVisible, skipLimitedItems })
      }
      else if (shouldFetchQueue) {
        actions.models.queue.fetch({ limit: 1 })
      }
    }

    render() {
      const { hasPostponedItems, ...rest } = this.props

      return (
        <ComposedComponent
          {...rest}
        />
      )
    }
  }

  return compose(
    connect({
      isLoggedIn: 'models.me.isLoggedIn',
      hasPostponedItems: () => (
        postponedLocalStorageNames.some((localStorageName) => (
          actions.misc.localStorage.getItem(localStorageName)
        ))
      ),
    }),
  )(WrappedComponent)
}
